export enum BalanceType {
  User = 1,
  Deposit = 2,
  Insurance = 3,
}

export interface TraderBalances {
  id: string
  createdAt: string
  lastModifiedAt: string
  balanceType: BalanceType
  cryptoCurrency: number
  amount: number
  frozen: number
  blocked: number
  received: number
  lastReceivedAt: string
}
